import React, { useEffect, useState } from "react";
import BottomNavbar from "../userNavbar/BottomNavbar";
import TopNavbar from "../userNavbar/TopNavbar";
import MiddleNavBar from "../userNavbar/MiddleNavBar";

const UserNavbar = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);  
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className="w-full">
   
      <TopNavbar />

      <div
        className={`${isSticky ? "fixed top-0" : "relative"} w-full z-[9999]`}
      >
        <MiddleNavBar />
        <BottomNavbar />
      </div>
    </div>
  );
};

export default UserNavbar;
